export default "__VITE_ASSET__B0oxd6WV__"